import React, { Component } from "react";
import {
  Typography,
  Paper,
  Tabs as Tabs1,
  Tab as Tab1,
} from "@material-ui/core";
import { GetData } from "../../api/service";
import AcademicAbout from "../Academics/AcademicAbout";
import CollegeNotificationShort from "../College/CollegeNotificationShort";

const smallTab = [
  {
    title: "Institutional Internship Policy",
    active: 0,
  },
  {
    title: "Institutional Apprenticeship Policy",
    active: 1,
  },
  {
    title: "Rules & Guidelines",
    active: 2,
  },
  {
    title: "Apply for NoC",
    active: 3,
  },
  {
    title: "Apply for Internship",
    active: 4,
  },
  {
    title: "Apply for Apprenticeships",
    active: 5,
  },
  {
    title: "Documents and Resources",
    active: 6,
  },
];

class ForStudentsHomeLanding extends Component {
  state = {
    active: 0,
    dept_code: "DISPUR",

    data: {},
    isDeptLoaded: false,
  };

  __getDeptData = (dept_code) => {
    GetData(`/admin/${dept_code}/getsingledeptdata`).then((resp) => {
      if (resp != false) {
        this.setState({
          data: resp,
          active: 0,
          isDeptLoaded: true,
        });
      } else {
        this.setState({
          data: {},
          active: 0,
          isDeptLoaded: true,
        });
      }
    });
  };

  componentDidMount() {
    this.__getDeptData(this.state.dept_code);
  }

  render() {
    return (
      <div>
        <Typography variant="h6">For Students</Typography>
        <Typography variant="subtitle2">
          Code: {this.state.dept_code}
        </Typography>

        <br />

        {this.state.isDeptLoaded && (
          <Paper square>
            <Tabs1
              value={this.state.active}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons="auto"
              onChange={(e, newValue) =>
                this.setState({
                  active: newValue,
                })
              }
              aria-label=""
            >
              {smallTab.map((el, index) => (
                <Tab1 value={el.active} key={el.active} label={el.title} />
              ))}
            </Tabs1>
          </Paper>
        )}
        <br />

        {this.state.active == 0 ? (
          <AcademicAbout
            type={`INSTITUTIONAL_INTERNSHIP_POLICY`}
            title="Institutional Internship Policy"
          />
        ) : null}

        {this.state.active == 1 ? (
          <AcademicAbout
            type={`INSTITUTIONAL_APPRENTICESHIP_POLICY`}
            title="Institutional Apprenticeship Policy"
          />
        ) : null}

        {this.state.active == 2 ? (
          <AcademicAbout
            type={`RULES_AND_GUIDELINES`}
            title="Rules & Guidelines"
          />
        ) : null}

        {this.state.active == 3 ? (
          <CollegeNotificationShort
            type={`APPLY_FOR_NOC`}
            title="Apply for NoC"
          />
        ) : null}

        {this.state.active == 4 ? (
          <CollegeNotificationShort
            type={`APPLY_FOR_INTERNSHIP`}
            title="Apply for Internship"
          />
        ) : null}

        {this.state.active == 5 ? (
          <CollegeNotificationShort
            type={`APPLY_FOR_APPRENTICESHIPS`}
            title="Apply for Apprenticeships"
          />
        ) : null}

        {this.state.active == 6 ? (
          <CollegeNotificationShort
            type={`DOCUMENTS_AND_RESOURCES`}
            title="Documents and Resources"
          />
        ) : null}
      </div>
    );
  }
}

export default ForStudentsHomeLanding;
